import React, { useContext } from 'react';
import { ApplicationTrackerContext } from '../../contexts/ApplicationTrackerContext';

const EmailAccessButton = React.forwardRef(({ onBeforeRequest }, ref) => {
  const { setAutoScraperInfoModalOpen } = useContext(ApplicationTrackerContext);

  function handleEmailAccess() {
    // Just open the confirmation modal
    setAutoScraperInfoModalOpen(true);

    // If there's a callback, execute it
    if (onBeforeRequest) {
      onBeforeRequest();
    }
  }

  return (
    <button
      ref={ref}
      onClick={handleEmailAccess}
      className="py-2 px-3 inline-flex items-center gap-x-2 text-md font-medium rounded-lg border-2 border-white text-white hover:border-white/70 hover:text-white/70 focus:outline-hidden focus:border-white/70 focus:text-white/70 disabled:opacity-50 disabled:pointer-events-none"
    >
      Sync with Gmail
    </button>
  );
});

export default EmailAccessButton;
